export const SAVE_MESSAGE_PRESET = {
  Home: {
    TBM_JOIN: {
      success: 'TBM 참석 처리가 완료되었습니다.',
      fail: 'TBM 참석 처리에 실패했습니다. QR코드를 다시 스캔해 주세요.',
    },
    WORK_END: {
      success: '작업 종료 보고가 전송되었습니다.',
      fail: '작업 종료 보고 중 오류가 발생했습니다. 네트워크 상태를 확인해 주세요.',
    },
  },
  AlarmList: {
    success: '알림을 확인했습니다.',
    fail: '알림 확인 처리 중 오류가 발생했습니다.',
  },

  M_AIC_BASIC: {
    SAVE_AI_CALL: {
      success:
        '보이스 체크 확인이 완료되었습니다. 안전하게 작업을 시작해 주세요.',
      fail: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    },
  },

  M_WOS_BASIC_01: {
    SAVE_WORK_STOP: {
      success: '비상연락망으로 보고되었습니다.',
      fail: '작업 중지 처리에 실패했습니다. 네트워크 상태를 확인해 주세요.',
    },
  },

  default: {
    success: '성공적으로 처리되었습니다.',
    fail: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
  },
};
